import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const putTenantLanguage = (token, id, TenantID, LanguageID) => {
    return fetch(`${apiUrl}tenant_languages/${id}`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            TenantID,
            LanguageID
        })
    });
}

export default putTenantLanguage